export const generateCreditCheckGridColumnStyle = (length: number) => {
  const frArray = Array.from({ length }, () => '1fr');
  // Edit button fr
  frArray.push('0.4fr');
  return frArray.join(' ');
};

export const getCreditCheckStatus = (status: CreditCheckStatus) => {
  switch (status) {
    case CreditCheckStatus.approved:
      return 'Approved';
    case CreditCheckStatus.denied:
      return 'Denied';
    case CreditCheckStatus.pending:
      return 'Pending';
    case CreditCheckStatus.manuallyReferred:
      return 'Manually Referred';
  }
};

export enum CreditCheckStatus {
  approved = 0,
  denied = 1,
  pending = 2,
  manuallyReferred = 3
}

const getStatus = (key: string) => {
  return CreditCheckStatus[key as keyof typeof CreditCheckStatus];
};

export const getCreditStatusOptions = () => {
  const values = Object.keys(CreditCheckStatus)
    .filter(key => !isNaN(Number(getStatus(key))))
    .map(key => {
      const value = getStatus(key);
      return {
        id: String(value),
        name: getCreditCheckStatus(value)
      };
    });

  return values;
};
